import { wrap as withStyle } from 'utils/styles'

export default withStyle(
  () => `
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
  position: relative;
`
)
